
































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';

import Logo from '@/components/Logo/Logo.vue';
import LogOutDialog from '@/components/LogOutDialog/LogOutDialog.vue';
import TimeoutError from '@/components/TimeoutError/TimeoutError.vue';

import OfflineMixin from '@/mixins/OfflineMixin';

@Component({
  components: {
    Logo,
    LogOutDialog,
    TimeoutError,
  },
  name: 'AppList',
})
export default class AppList extends Mixins(OfflineMixin) {
  highlightSystemApps = false;
  searchResults: AppStore.Release[] = [];
  searchTerm = '';

  filterSearchResults(apps: AppStore.Release[], keyword: string | null): AppStore.Release[] {
    return apps.filter((item: AppStore.Release) => {
      if (!item) {
        return [];
      }

      const keys = Object.keys(item);

      return keys.some((key: string) => {
        const result = item[key]
          .toString()
          .toLowerCase()
          .includes((keyword || '').toLowerCase());

        return result;
      });
    });
  }

  @Watch('searchTerm')
  onSearchTermChange(value: string): AppStore.Release[] {
    if (this.searchTerm === '') {
      return [];
    }

    const { error } = this.$store.state['app-data'];

    if (error) {
      return [];
    }

    const { apps } = this.$store.state['app-data'];
    const tempApps = [...apps];

    this.searchResults = this.filterSearchResults(tempApps, value);
    return this.filterSearchResults(tempApps, value);
  }

  public mounted(): void {
    this.getAppListData();

    this.$on('online', async () => {
      await this.getAppListData();
    });
  }

  async getAppListData(): Promise<void> {
    const token = await this.$auth.getTokenSilently({});

    const options = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    try {
      await this.$store.dispatch('app-data/fetch', options);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  async logout(): Promise<void> {
    await this.$auth.logout({ returnTo: window.location.origin });
  }

  async reloadCallback(): Promise<void> {
    this.getAppListData();
    await this.$store.commit('app-data/resetStore');
  }
}
